import {
  AppNotification,
  normalizeNotification,
} from "../types/notification.definition";
import {
  deleteNotification,
  getNotifications,
  markAllNotificationsAsRead,
  markNotificationAsRead,
} from "../webclients/notification.client";

export const notificationApi = {
  getNotifications: async (): Promise<AppNotification[]> => {
    const response = await getNotifications();
    return (response.data ?? []).map(normalizeNotification);
  },
  markAsRead: async (id: number): Promise<AppNotification> => {
    const response = await markNotificationAsRead(id);
    return normalizeNotification(response.data);
  },
  markAllAsRead: async (): Promise<void> => {
    await markAllNotificationsAsRead();
  },
  deleteNotification: async (id: number): Promise<void> => {
    await deleteNotification(id);
  },
};
